import { DataBean } from "../DataBean";

export class StateConstantsForWIP extends DataBean {



    public async getProductionOrderStateConstantsForWIP(id): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderStateConstantsForWIP_Number", [id]);
    }
    
}